import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import {
  Box,
  Image,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Stack,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { IoArrowRedoSharp } from "react-icons/io5";

function ShareToSocial({ sm, id, username }) {
  const modeBoxShadow = useColorModeValue("#80808024", "#030c1b");

  const circleStyle = {
    bg: "#fff",
    w: sm ? "20px" : "40px",
    h: sm ? "20px" : "40px",

    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: `2px 2px 14px 0px ${modeBoxShadow}`,
  };

  return (
    <Popover isLazy size={"sm"}>
      <PopoverTrigger>
        <Box>
          <Tooltip label={"share"}>
            <Box {...circleStyle} cursor="pointer">
              <IoArrowRedoSharp color="#4F0A83" fontSize={sm ? "1em" : "2em"} />
            </Box>
          </Tooltip>
        </Box>
      </PopoverTrigger>
      <PopoverContent width="250px" _focus={{ boxShadow: "none" }}>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>Share!</PopoverHeader>
        <PopoverBody>
      
          <Stack direction={"row"} alignItems="center" flexWrap={"wrap"}>
            <EmailShareButton
              url={`${window.location.href}view-profile/${username}`}
              body={`Here's a link to my profile `}
              subject={`View ${username} profile`}
            >
              <EmailIcon size={32} round={true} />
            </EmailShareButton>
            <WhatsappShareButton
              title={`View ${username} profile`}
              url={`${window.location.href}view-profile/${username}`}
            >
              <WhatsappIcon size={32} round={true} />
            </WhatsappShareButton>
            <FacebookShareButton
              quote={`View ${username} profile`}
              url={`${window.location.href}view-profile/${username}`}

            >
              <FacebookIcon size={32} round={true} />
            </FacebookShareButton>
            <TwitterShareButton
              title={`View ${username} profile`}
              url={`${window.location.href}view-profile/${username}`}
            >
              <TwitterIcon size={32} round={true} />
            </TwitterShareButton>
          </Stack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default ShareToSocial;
